import React from "react";
import PropTypes from "prop-types";
import { Chip } from "@mui/material";

const ActiveStatusCell = ({ value }) => (
  <Chip
    label={value === "ACTIVE" || value === true || value === 1 ? "Active" : "Inactive"}
    color={value === "ACTIVE" || value === true || value === 1 ? "success" : "error"}
    size="medium"
    variant="outlined"
  />
);

ActiveStatusCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.bool, PropTypes.string]).isRequired,
};

export default ActiveStatusCell;
